import React from 'react';
import PropTypes from 'prop-types';
import PodcastListWidget from 'components_v2/common/PodcastListWidget';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import Link from 'components/Link';
import s from './PodcastWidget.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';

class PodcastWidget extends React.Component {
  cardClickHandler = data => {
    if (data && data.wu) {
      if (data.target === '_blank') {
        window.open(data.wu);
      } else {
        window.location.href = data.wu;
      }
    }
    if (
      typeof this.props.ga4Type !== 'undefined' &&
      this.props.ga4Type !== ''
    ) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: this.props.ga4Type,
        category: 'story_click',
        story_no: '1',
        msid: data?.id,
      });
    }
  };
  render() {
    const { sectionItem, ga4Type, ga4Category } = this.props;
    return (
      <>
        <InViewObserver
          inViewCallback={() => {
            if (
              typeof sectionItem.ga4Type !== 'undefined' &&
              sectionItem.ga4Type !== ''
            ) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: sectionItem?.ga4Type,
                category: sectionItem?.ga4Category,
              });
            }
          }}
        >
          {sectionItem.border &&
            sectionItem.border === 'top' && (
              <InterSectionBorder border={sectionItem.border} />
            )}
          <div className={s.podcastWidget}>
            <Link
              to={sectionItem.path}
              className={s.heading}
              target={sectionItem.target}
              ga4Data={
                ga4Type && [
                  {
                    event: 'user_click',
                    type: `${
                      sectionItem?.ga4Type ? sectionItem?.ga4Type : ga4Type
                    }`,
                    label: `${sectionItem.name.toLowerCase()}`,
                    category: `${'section_heading_click' || ga4Category}`,
                  },
                ]
              }
            >
              {sectionItem.name}
            </Link>
            <div className={s.podcastInner}>
              <div className={s.pageHeader}>
                <h2 className={s.heading}>Pressed for time?</h2>
                <p className={s.text}>
                  Hear the latest Podcasts episodes on the go
                </p>
              </div>
              <div className={s.slider}>
                <ul className={s.lists}>
                  {sectionItem.items &&
                    sectionItem.items.length > 0 &&
                    sectionItem.items.map(item => (
                      <PodcastListWidget
                        data={{ ...item, imgWidth: 500 }}
                        key={item.id}
                        onClick={this.cardClickHandler}
                      />
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </InViewObserver>
      </>
    );
  }
}

PodcastWidget.propTypes = {
  sectionItem: PropTypes.shape({}).isRequired,
  // cssSelector: PropTypes.string,
  // gaCategory: PropTypes.string,
  // gaAction: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

PodcastWidget.defaultProps = {
  // cssSelector: '',
  // gaCategory: '',
  // gaAction: 'Click',
  ga4Type: '',
  ga4Category: '',
};
export default PodcastWidget;
